import  { TurnoverController } from "./turnover_controller.js"
import Highcharts from 'highcharts'

export default class extends TurnoverController {

  connect() {
    this.changePeriod()
  }

  initChart() {
    let options

    if (this.stackingValue) {
      options = {
        chart: { type: 'line' }
      }
    } else {
      options = {
        chart: { type: 'column' },
        plotOptions: { column: { stacking: 'normal' } }
      }
    }

    let dataType = this.formTarget.querySelector("[data-type-select]").value

    if(dataType == 'regs_count' || dataType == 'subs_count') {     
      this.chart = Highcharts.chart(this.chartTarget, {
        ...options,
        yAxis: { title: { text: "Quantité d'abonnements" } },
        tooltip: { formatter: function() { return `<strong>${this.series.name}</strong><br/>${this.x}: ${Highcharts.numberFormat(this.y)}` } },
        exporting: { buttons: { contextButton: { menuItems: ['downloadXLS', 'downloadCSV'] } } },
        navigation: { menuItemHoverStyle: { background: '#db2777', color: '#ffffff' } }
      })
    } else {
      
      super.initChart()
    }
  }
}
